// components/FormularioPesquisa.js
import React from 'react';
import { Button, Grid, CircularProgress, Typography, Container } from '@mui/material';
import Pergunta from './Pergunta';

const FormularioPesquisa = ({
  perguntas,
  respostas,
  handleChange,
  handleSubmit,
  loading,
  renderSubPerguntas,
  setRespostas, // Recebendo setRespostas
  modoEdicao,
  classes
}) => {
	// console.log("setRespostas em ResponderQuestionario:", setRespostas);
  return (
    <Container>
      {loading ? (
        <div className={classes.loadingContainer}>
          <CircularProgress />
        </div>
      ) : (
        <>
          <Typography variant="h4" className={classes.titulo}>Pesquisa</Typography>
          {perguntas.filter(pergunta => !pergunta.pai_id).map((pergunta) => (
            <Pergunta
              key={pergunta.id}
              pergunta={pergunta}
              respostas={respostas}
              handleChange={handleChange}
              renderSubPerguntas={renderSubPerguntas}
              setRespostas={setRespostas} // Passando setRespostas
              modoEdicao={modoEdicao}
              classes={classes}
            />
          ))}
          <Grid container spacing={2}>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? 'Enviando...' : 'Enviar'}
              </Button>
            </Grid>
          </Grid>
        </>
      )}
    </Container>
  );
};

export default FormularioPesquisa